module.exports = __webpack_public_path__ + "static/media/live-playground.b1febecd.svg";